<template>
  <div>
    <v-card class="search-client-card border">
      <v-card-title class="search-client-card__title">
        <v-icon left class="search-client-card__icon">mdi-account-check</v-icon>
        <span class="search-client-card__label">Это наш клиент!</span>
        <v-btn
          icon
          class="search-client-card__close"
          @click="closeModal"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="search-client-card__content pa-4 pa-sm-6 pb-8">
        <div class="search-client-card__toolbar" v-if="clients && clients.length">
          <v-spacer />
          <v-btn
            v-if="hasDoorphonesOverflowInTable"
            small
            outlined
            color="grey darken-1"
            class="text-none"
            @click="toggleAllClientsExpanded"
          >
            <v-icon left small>{{ areAllExpanded ? 'mdi-unfold-less-horizontal' : 'mdi-unfold-more-horizontal' }}</v-icon>
            {{ areAllExpanded ? 'Скрыть' : 'Раскрыть' }}
          </v-btn>
        </div>
        <v-data-table
          class="table"
          v-if="clients[0]"
          :headers="headers"
          :items="clients"
          disable-sort
          :server-items-length="totalClients"
          :options.sync="localOptions"
          :footer-props="{
            'items-per-page-options': [5, 15, 50],
            showFirstLastPage: true,
          }"
          >
          <template v-slot:item.telephone="{ item }">
            <span>{{ formatPhoneNumber(item.telephone) }}</span>
            <v-tooltip v-if="item.without_doorphone" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on" x-small color="orange" text-color="white" class="ml-2">
                  Без домофона
                </v-chip>
              </template>
              <span>Клиент только с шлагбаумами (без домофона)</span>
            </v-tooltip>
          </template>
          <template v-slot:item.doorphones="{ item }">
            <template v-if="item.without_doorphone">
              <span class="grey--text">—</span>
            </template>
            <template v-else>
              <ul v-for="doorphone in getVisibleDoorphones(item)" v-bind:key="doorphone.id">
                <router-link class="routerLink" :to="`/doorphones/${doorphone.id}`" @click.prevent="closeModal">
                  {{ getDoorphoneAddress(doorphone) }}
                </router-link>
              </ul>
              <span v-if="isCollapsedWithOverflow(item, getDoorphones(item).length)" class="grey--text">...</span>
              <span v-if="!getDoorphones(item).length" class="grey--text">—</span>
            </template>
          </template>
          <template v-slot:item.barriers="{ item }">
            <template v-if="item.without_doorphone">
              <ul v-for="barrier in getVisibleBarriersForWithoutDoorphone(item)" v-bind:key="barrier.id">
                <router-link class="routerLink" :to="`/barrier/${barrier.id}`" @click.prevent="closeModal">
                  {{ barrier.address || `Шлагбаум ID ${barrier.id}` }}
                </router-link>
              </ul>
              <span v-if="isCollapsedWithOverflow(item, getBarriersForWithoutDoorphone(item).length)" class="grey--text">...</span>
              <span v-if="!getBarriersForWithoutDoorphone(item).length" class="grey--text">—</span>
            </template>
            <template v-else>
              <ul v-for="barrier in getVisibleBarriers(item)" v-bind:key="barrier.id">
                <router-link class="routerLink" :to="`/barrier/${barrier.id}`">
                  {{ barrier.address }}
                </router-link>
              </ul>
              <span v-if="isCollapsedWithOverflow(item, getBarriers(item).length)" class="grey--text">...</span>
              <span v-if="!getBarriers(item).length" class="grey--text">—</span>
            </template>
          </template>
          <template v-slot:item.StatusClient="{ item }">
            <template v-if="getStatusClient(item).length">
              <ul v-for="apartment_sip_settings in getVisibleStatusClient(item)" v-bind:key="apartment_sip_settings.id">
                {{ getStatusPaid(apartment_sip_settings.paid) }}
              </ul>
              <span v-if="isCollapsedWithOverflow(item, getStatusClient(item).length)" class="grey--text">...</span>
            </template>
            <span v-else class="grey--text">—</span>
          </template>
          <template v-slot:item.status="{ item }">
            <ul v-for="(status, idx) in getVisibleStatuses(item)" v-bind:key="idx">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    text
                    tile
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="btn__icon pa-0"
                    width="18"
                    height="18"
                    style="cursor: default;"
                  >
                    <v-icon
                      :color="(status === 'A') ? 'green' : (status === 'B') ? 'yellow' : 'red'"
                      x-small
                    >
                      mdi-checkbox-blank-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ getStatusesClients(status) }}</span>
              </v-tooltip>
            </ul>
            <span v-if="isCollapsedWithOverflow(item, getStatuses(item).length)" class="grey--text">...</span>
          </template>
          <template v-slot:item.Code="{ item }">
            <template v-if="getKeys(item).length">
              <ul v-for="keys in getVisibleKeys(item)" v-bind:key="keys.id">
                {{ keys.code }}
              </ul>
              <span v-if="isCollapsedWithOverflow(item, getKeys(item).length)" class="grey--text">...</span>
            </template>
            <span v-else class="grey--text">—</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <template v-if="$canRoute('DetailClientGeneralInfoClient')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    text
                    tile
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="btn__icon pa-0"
                    width="18"
                    height="18"
                    @click.prevent="closeModal"
                    :to="`/client/${item.id}`"
                  >
                    <v-icon>mdi-information-slab-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Информация</span>
              </v-tooltip>
            </template>
            <template v-else><v-icon disabled>mdi-information-slab-circle-outline</v-icon></template>
          </template>
        </v-data-table>
        <div v-if="hasDoorphonesOverflowInTable" class="search-client-card__hint grey--text text--darken-1">
          <template v-if="areAllExpanded">
            Вся информация отображена.
          </template>
          <template v-else>
            Сейчас отображается короткая информация. Дополнительные значения скрыты и обозначаются как ...
          </template>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SearchClient',
  props: {
    clients: {
      type: Array,
    },
    totalClients: {
      type: Number,
    },
    options: Object,
  },
  data () {
    return {
      localOptions: this.options,
      maxVisibleItems: 5,
      expandedClients: {},
      headers: [
        { text: 'Телефон', value: 'telephone', align: 'center' },
        { text: 'Домофон', value: 'doorphones', align: 'center' },
        { text: 'Шлагбаум', value: 'barriers' },
        { text: 'Код ключа', value: 'Code', align: 'center' },
        { text: 'Статус аккаунта', value: 'StatusClient', align: 'center' },
        { text: 'Статус', value: 'status', align: 'center' },
        { text: '', value: 'actions', sortable: false, align: 'center' },
      ],
      searchPhone: '',
      isHovered: false,
    };
  },
  watch: {
    localOptions: {
      handler (newOptions) {
        this.$emit('update:options', newOptions);
      },
      deep: true,
    },
  },
  computed: {
    hasDoorphonesOverflowInTable () {
      if (!Array.isArray(this.clients)) return false;
      return this.clients.some(item => this.getDoorphones(item).length > this.maxVisibleItems);
    },
    hasAnyOverflowInTable () {
      if (!Array.isArray(this.clients)) return false;
      return this.clients.some(item => this.hasAnyOverflow(item));
    },
    areAllExpanded () {
      if (!Array.isArray(this.clients) || !this.clients.length) return false;
      const overflowClients = this.clients.filter(item => this.hasAnyOverflow(item));
      if (!overflowClients.length) return false;
      return overflowClients.every(item => this.isClientExpanded(item.id));
    },
  },
  methods: {
    ...mapActions({
    }),
    formatPhoneNumber (phoneNumber) {
      phoneNumber = phoneNumber.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ' (калитка)';
      }
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}, кв.${doorphone.apartment}`;
        if (doorphone.type === 'A') {
          address += ' (доп.вход)';
        }
      }
      return address;
    },
    getStatusPaid (paid) {
      switch (paid) {
        case true: return ' Pro - версия';
        case false: return ' Lite - версия';
      }
    },
    getStatusesClients (status) {
      switch (status) {
        case 'A': return ' Активен ';
        case 'B': return ' Заблокирован ';
        case 'D': return ' Удален ';
      }
    },
    getBarriersForWithoutDoorphone (item) {
      if (item.barriers && Array.isArray(item.barriers) && item.barriers.length > 0) {
        return item.barriers;
      }
      if (item.barrier_ids && Array.isArray(item.barrier_ids)) {
        return item.barrier_ids.map(id => ({ id, address: `Шлагбаум ID ${id}` }));
      }
      return [];
    },
    getDoorphones (item) {
      const doorphones = [];
      if (!item.abonents || !item.abonents.length) return doorphones;
      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            doorphone.apartment = abonent.apartment;
            doorphones.push(doorphone);
          });
        }
      });
      return doorphones;
    },
    getVisibleDoorphones (item) {
      const allDoorphones = this.getDoorphones(item);
      if (this.isClientExpanded(item.id)) return allDoorphones;
      return allDoorphones.slice(0, this.maxVisibleItems);
    },
    getVisibleBarriers (item) {
      const barriers = this.getBarriers(item);
      if (this.isClientExpanded(item.id)) return barriers;
      return barriers.slice(0, this.maxVisibleItems);
    },
    getVisibleBarriersForWithoutDoorphone (item) {
      const barriers = this.getBarriersForWithoutDoorphone(item);
      if (this.isClientExpanded(item.id)) return barriers;
      return barriers.slice(0, this.maxVisibleItems);
    },
    getVisibleKeys (item) {
      const keys = this.getKeys(item);
      if (this.isClientExpanded(item.id)) return keys;
      return keys.slice(0, this.maxVisibleItems);
    },
    getVisibleStatusClient (item) {
      const statuses = this.getStatusClient(item);
      if (this.isClientExpanded(item.id)) return statuses;
      return statuses.slice(0, this.maxVisibleItems);
    },
    getVisibleStatuses (item) {
      const statuses = this.getStatuses(item);
      if (this.isClientExpanded(item.id)) return statuses;
      return statuses.slice(0, this.maxVisibleItems);
    },
    isClientExpanded (clientId) {
      return !!this.expandedClients[clientId];
    },
    toggleClientExpanded (clientId) {
      this.$set(this.expandedClients, clientId, !this.isClientExpanded(clientId));
    },
    toggleAllClientsExpanded () {
      const nextState = !this.areAllExpanded;
      (this.clients || []).forEach(item => {
        if (this.hasAnyOverflow(item)) {
          this.$set(this.expandedClients, item.id, nextState);
        }
      });
    },
    hasAnyOverflow (item) {
      return this.getDoorphones(item).length > this.maxVisibleItems || this.getBarriers(item).length > this.maxVisibleItems || this.getBarriersForWithoutDoorphone(item).length > this.maxVisibleItems || this.getKeys(item).length > this.maxVisibleItems || this.getStatusClient(item).length > this.maxVisibleItems || this.getStatuses(item).length > this.maxVisibleItems;
    },
    isCollapsedWithOverflow (item, totalCount) {
      return !this.isClientExpanded(item.id) && totalCount > this.maxVisibleItems;
    },
    getBarriers (item) {
      const barriersSet = new Set();
      if (!item.abonents || !item.abonents.length) return [];
      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            if (doorphone.barriers) {
              doorphone.barriers.forEach(barrier => {
                barriersSet.add(barrier);
              });
            }
          });
        }
      });

      return Array.from(barriersSet);
    },
    getKeys (item) {
      const keys = [];
      if (!item.abonents || !item.abonents.length) return keys;
      item.abonents.forEach(abonent => {
        if (abonent.keys) {
          abonent.keys.forEach(doorphone => {
            keys.push(doorphone);
          });
        }
      });
      return keys;
    },
    getStatusClient (item) {
      const apartmentSipSettings = [];
      if (!item.abonents || !item.abonents.length) return apartmentSipSettings;
      item.abonents.forEach(abonent => {
        if (abonent.apartment_sip_settings) {
          abonent.apartment_sip_settings.forEach(doorphone => {
            apartmentSipSettings.push(doorphone);
          });
        }
      });
      return apartmentSipSettings;
    },
    getStatuses (item) {
      const status = [];
      if (!item.abonents || !item.abonents.length) return status;
      item.abonents.forEach(abonent => {
        status.push(abonent.status);
      });
      return status;
    },
    closeModal () {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-client-card {
  overflow: hidden;
}

.search-client-card__title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 16px 48px 16px 16px;
  background: linear-gradient(135deg, #d4a574 0%, #c4956a 50%, #b8865f 100%);
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.search-client-card__icon {
  margin-right: 10px;
  opacity: 0.95;
}

.search-client-card__label {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.search-client-card__close {
  position: absolute;
  top: 50%;
  right: 8px;
  margin-top: -20px;
  color: rgba(255, 255, 255, 0.9) !important;

  &:hover {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.15) !important;
  }
}

.search-client-card__content {
  background: #fafafa;
}

.search-client-card__toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.search-client-card__hint {
  margin-top: 8px;
  font-size: 0.8125rem;
  text-align: left;
}

.border {
  border-radius: 16px;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .search-client-card__title {
    font-size: 1.1rem;
    padding-left: 12px;
  }

  .search-client-card__icon {
    font-size: 1.25rem !important;
  }
}
</style>
